export const RISK_LABELS = { 1: "货运险", 2: "雇主险" };
export const RISK_KEYS = { 1: "hyx", 2: "ygx" };

export const CASE_PROGRESS = {
  0: "-",
  1: "已报案",
  2: "初次提交资料",
  4: "审核通过",
  8: "保险公司定损",
  16: "签订赔偿协议",
  32: "支付赔款",
  64: "已结案"
};

export const CASE_STATUS = { 1: "已决", 2: "异常", 4: "销案", 8: "未决" };
export const JOBS = { 1: "搬运工人", 2: "文员内勤", 4: "司机押运" };
export const DISABILITY_LEVELS = [
  "无",
  "一级伤残",
  "二级伤残",
  "三级伤残",
  "四级伤残",
  "五级伤残",
  "六级伤残",
  "七级伤残",
  "八级伤残",
  "九级伤残",
  "十级伤残"
];
export const CIRCULATION_TIMES = {
  1: "10天",
  2: "20天",
  4: "30天",
  8: "2个月",
  16: "3个月"
};

export const CARGO_CONSEQUENCES = [
  "返厂维修",
  "更换包装",
  "降等处理",
  "销毁",
  "全损",
  "部分受损"
];
export const EMPLOYER_CONSEQUENCES = [
  "门诊",
  "住院非手术",
  "住院手术",
  "当场死亡",
  "经抢救无效死亡"
];
export const ROAD_TYPES = ["一般道路", "高速道路", "国道道路"];

export const MEDIA_TYPES = [
  { id: 1, risk: 2, group: "伤者资料", name: "劳动合同" },
  { id: 2, risk: 2, group: "伤者资料", name: "考勤表" },
  { id: 3, risk: 2, group: "伤者资料", name: "工资流水" },
  { id: 4, risk: 2, group: "伤者资料", name: "医疗资料" },
  { id: 5, risk: 2, group: "伤者资料", name: "门诊住院发票" },
  { id: 6, risk: 2, group: "伤者资料", name: "伤者身份证复印件" },
  {
    id: 7,
    risk: 2,
    group: "伤者资料",
    name: "被保险人营业执照、法人身份证复印件"
  },
  { id: 8, risk: 2, group: "伤者资料", name: "建休证明" },
  { id: 9, risk: 2, group: "伤者资料", name: "事故影像资料" },
  { id: 10, risk: 2, group: "伤者资料", name: "死者与受益人证明资料" },
  { id: 11, risk: 2, group: "伤者资料", name: "死亡证明、火化证明" },
  { id: 12, risk: 2, group: "伤者资料", name: "受益人身份证复印件等" },
  { id: 13, risk: 2, group: "单证资料", name: "出险通知书" },
  { id: 14, risk: 2, group: "单证资料", name: "赔偿确认书、赔偿协议" },
  { id: 15, risk: 2, group: "单证资料", name: "收款账户" },
  { id: 16, risk: 2, group: "单证资料", name: "工伤认定书" },
  { id: 17, risk: 2, group: "单证资料", name: "伤残鉴定报告" },
  { id: 18, risk: 1, group: "事故证明资料", name: "交通事故认定书" },
  { id: 19, risk: 1, group: "事故证明资料", name: "消防事故证明书" },
  { id: 20, risk: 1, group: "事故证明资料", name: "出险通知书" },
  { id: 21, risk: 1, group: "事故证明资料", name: "赔偿确认书" },
  { id: 22, risk: 1, group: "事故证明资料", name: "检测报告" },
  { id: 23, risk: 1, group: "事故证明资料", name: "营业执照，法人身份证" },
  { id: 24, risk: 1, group: "事故证明资料", name: "公安报案回执单" },
  { id: 25, risk: 1, group: "事故证明资料", name: "气象证明" },
  { id: 26, risk: 1, group: "事故证明资料", name: "驾驶员驾驶证" },
  { id: 27, risk: 1, group: "事故证明资料", name: "从业资格证" },
  { id: 28, risk: 1, group: "事故证明资料", name: "车辆行驶证" },
  { id: 29, risk: 1, group: "事故证明资料", name: "道路运输许可证" },
  { id: 30, risk: 1, group: "货物损失资料", name: "货物价值凭证" },
  { id: 31, risk: 1, group: "货物损失资料", name: "损失清单" },
  { id: 32, risk: 1, group: "货物损失资料", name: "运输协议、装车清单、运单" },
  {
    id: 33,
    risk: 1,
    group: "货物损失资料",
    name: "事故现场照片、货损照片、视频"
  },
  { id: 34, risk: 1, group: "货物损失资料", name: "赔付证明" },
  { id: 35, risk: 1, group: "货物损失资料", name: "运费抵扣清单" },
  { id: 36, risk: 1, group: "货物损失资料", name: "维修报价单" }
];

export const formatDate = value => {
  if (!value || value === "0001-01-01T00:00:00Z") return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime()) || date.getFullYear() === 1) return "-";
  const pad = number => String(number).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}`;
};

export const formatDateTime = value => {
  const dateOnly = formatDate(value);
  if (dateOnly === "-") return dateOnly;
  const date = new Date(value);
  const pad = number => String(number).padStart(2, "0");
  return `${dateOnly} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
};

export const fromCents = value =>
  value === null || value === undefined ? "" : Number(value) / 100;
export const toCents = value =>
  value === "" || value === null || value === undefined
    ? 0
    : Math.ceil(Number(value) * 100);
export const toTimestamp = value =>
  value ? Math.floor(new Date(value).getTime() / 1000) : 0;
